module.exports = __webpack_public_path__ + "static/media/bell_white.19645a91.svg";